import React from "react";
import { Band, Glow, Eyebrow, Reveal, Check, PrimaryCTA } from "./shared";
import { DeviceSlider } from "./DeviceSlider";
import { BPT_BENEFITS } from "./content";

export function DeviceSection() {
  return (
    <Band id="device" tone="alt">
      <div className="grid lg:grid-cols-2 gap-12 items-center">
        <Reveal>
          <div className="relative">
            <Glow className="-inset-6 w-full h-full bg-[#22D3EE]/12" />
            <div className="relative">
              <DeviceSlider />
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.12}>
          <Eyebrow className="text-[#22D3EE]">The Hardware</Eyebrow>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold uppercase tracking-tight text-white mt-3 leading-[1.05]">
            Featuring The Back Pain Transformer
          </h2>
          <p className="text-base text-[#B8C7DC] mt-5">
            A State-of-the-art patented full body support designed for optimum results.
          </p>
          <ul className="mt-7 space-y-4">
            {BPT_BENEFITS.map((b) => (
              <li key={b.t} className="flex items-start gap-4">
                <span className="shrink-0 w-7 h-7 rounded-lg bg-[#22D3EE]/12 border border-[#22D3EE]/25 flex items-center justify-center mt-0.5">
                  <Check className="w-4 h-4 text-[#22D3EE]" />
                </span>
                <div>
                  <div className="font-display font-semibold text-white">{b.t}</div>
                  <div className="text-sm text-[#9AAEC6] mt-0.5">{b.d}</div>
                </div>
              </li>
            ))}
          </ul>
          <div className="mt-8"><PrimaryCTA testid="device-cta" /></div>
        </Reveal>
      </div>
    </Band>
  );
}
